import Layout from "@/components/feature/Layout";
import PageHero from "@/components/feature/PageHero";
import Button from "@/components/base/Button";
import CTASection from "@/components/feature/CTASection";
import { useSiteData } from "@/context/SiteDataContext";
import { useT } from "@/lib/useSiteText";

export default function Planes() {
  const { data, whatsappLink } = useSiteData();
  const t = useT();
  const planes = data.planes;
  const hero = data.pages.planes;

  return (
    <Layout>
      <PageHero
        titulo={hero.hero_titulo}
        descripcion={hero.hero_descripcion}
        imagen={hero.hero_imagen_url}
        alt={hero.hero_imagen_alt}
      />

      <section className="bg-background-50">
        <div className="mx-auto max-w-7xl px-4 md:px-6 py-14 md:py-20">
          <div className="grid grid-cols-1 gap-6">
            {planes.map((plan, idx) => (
              <div
                key={plan.id}
                className="grid grid-cols-1 lg:grid-cols-2 rounded-lg border border-background-200 bg-background-50 overflow-hidden"
              >
                <div className={`relative h-64 lg:h-auto ${idx % 2 === 1 ? "lg:order-2" : ""}`}>
                  <img
                    src={plan.imagen_url}
                    alt={plan.imagen_alt}
                    className="absolute inset-0 w-full h-full object-cover object-top"
                  />
                </div>
                <div className={`p-7 md:p-10 ${idx % 2 === 1 ? "lg:order-1" : ""}`}>
                  <div className="flex items-center gap-3">
                    <span className="rounded-md bg-primary-100 text-primary-700 px-3 py-1 text-xs font-bold">
                      {plan.rango}
                    </span>
                    <h2 className="font-heading font-bold text-xl md:text-2xl text-foreground-950">{plan.nombre}</h2>
                  </div>
                  <p className="mt-4 text-foreground-600 leading-relaxed">{plan.descripcion}</p>

                  <div className="mt-5">
                    <h3 className="text-sm font-semibold text-foreground-500">{t("planes.ideal_para")}</h3>
                    <div className="mt-2 flex flex-wrap gap-2">
                      {plan.usos.map((uso) => (
                        <span
                          key={uso}
                          className="text-xs rounded-full bg-background-100 text-foreground-700 px-3 py-1.5 whitespace-nowrap"
                        >
                          {uso}
                        </span>
                      ))}
                    </div>
                  </div>

                  <div className="mt-5">
                    <h3 className="text-sm font-semibold text-foreground-500">{t("planes.incluye")}</h3>
                    <ul className="mt-2 grid grid-cols-1 sm:grid-cols-2 gap-2">
                      {plan.caracteristicas.map((c) => (
                        <li key={c} className="flex items-center gap-2 text-sm text-foreground-700">
                          <span className="w-5 h-5 rounded-full bg-secondary-100 text-secondary-700 flex items-center justify-center">
                            <i className="ri-check-line text-xs" />
                          </span>
                          {c}
                        </li>
                      ))}
                    </ul>
                  </div>

                  <div className="mt-7 flex flex-col sm:flex-row gap-3">
                    <Button
                      href={whatsappLink(t("wa.cotizar_plan", { nombre: plan.nombre.toLowerCase() }))}
                      variant="accent"
                      icon="ri-whatsapp-line"
                    >
                      {t("planes.cotizar")}
                    </Button>
                    <Button to="/bodegas" variant="outline">
                      {t("planes.ver_unidades")}
                    </Button>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-12 rounded-lg bg-background-100 p-7 md:p-10">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-center">
              <div>
                <p className="font-heading font-bold text-2xl text-foreground-950">{t("planes.info1_titulo")}</p>
                <p className="mt-1 text-sm text-foreground-600">{t("planes.info1_texto")}</p>
              </div>
              <div>
                <p className="font-heading font-bold text-2xl text-foreground-950">{t("planes.info2_titulo")}</p>
                <p className="mt-1 text-sm text-foreground-600">{t("planes.info2_texto")}</p>
              </div>
              <div>
                <p className="font-heading font-bold text-2xl text-foreground-950">{t("planes.info3_titulo")}</p>
                <p className="mt-1 text-sm text-foreground-600">{t("planes.info3_texto")}</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <CTASection />
    </Layout>
  );
}